export default __webpack_public_path__ + "static/media/kc.e0b47f29.png";